export default "__VITE_ASSET__Dv292S9g__"